/* eslint-disable no-unused-vars */
import { t } from 'i18next';
import { translatedText } from '../../i18n/config';

export function tradCorporateLayout() {
    const tradCorporateLayoutLogout = translatedText('logout', t);
    return { tradCorporateLayoutLogout };
}
